import React, { Fragment, FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Course, Player, PlayerResult, TeamGameMatch, TeamGameMatchTeam } from '../../../../../database.schema';
import * as CSS from '../../match-entry-styles';
import { FlexRowSpaceEvenly, Button } from '../../../common-styles/common-styles';

type TeamDisplayProps = {
  selectedTournamentIndex: number;
  teams: Array<TeamGameMatchTeam>;
  players: Array<Player>;
  matchIndex: number;
};

export const TeamsDisplay: FC<TeamDisplayProps> = ({ teams, selectedTournamentIndex, players, matchIndex }): JSX.Element => {
  const navigate = useNavigate();

  const scoresEntered = (team: TeamGameMatchTeam): boolean => {
    return team.players.some((player) => player.round.courseHandicap !== -1);
  };

  return (
    <Fragment>
      {teams.map((team, teamIndex: number) => (
        <CSS.MatchWrapper key={`stored-match-${teamIndex}`} data-testid="match-wrapper">
          <h3>{`Team ${teamIndex + 1}`}</h3>
          <FlexRowSpaceEvenly>
            <CSS.CreatedMatch data-testid={`team-${teamIndex}`} bgColour={teamIndex === 0 ? 'red' : 'blue'}>
              <div>
                {team.players.map((player: PlayerResult, playerIndex) => (
                  <div data-testid={`team-${teamIndex}-player-${playerIndex}`} key={`team-player-${player.playerId}`}>
                    {players.find((player1: Player) => player1.id === player.playerId)?.nickName}
                  </div>
                ))}
              </div>
            </CSS.CreatedMatch>
          </FlexRowSpaceEvenly>
          <Button
            data-testid={`enter-scores-${teamIndex}`}
            onClick={() => {
              navigate(`/${scoresEntered(team) ? 'edit' : 'add'}-team-game-scorecard/${selectedTournamentIndex}/${matchIndex}/${teamIndex}`);
            }}
          >
            {scoresEntered(team) ? 'Edit scores' : 'Add scores'}
          </Button>
        </CSS.MatchWrapper>
      ))}
    </Fragment>
  );
};
